module.exports = __webpack_public_path__ + "img/bhl2.4389e7d4.webp";